import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getMissingRequirements),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(showCancelReservationModal),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doHandleScheduleAction),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(watchScheduleCtaSagas);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, fork, select, put, takeEvery } from 'redux-saga/effects';
import { CANCELLATION_LATE } from 'constants/cancellation-types';
import SchedulesDeriver from 'derivers/Schedules';
import { deepExtract } from 'helpers/deep';
import { isEmpty } from 'helpers/verify';
import { showModal } from 'redux/modules/modals';
import { userProfile } from 'redux/saga/entities/bound';
import { isLoggedIn } from 'redux/saga/selectors/user';
import shiftTimezone from 'tz-offsets';
var SCHEDULE_ACTION = 'ScheduleCta/SCHEDULE_ACTION';
export var handleScheduleAction = function handleScheduleAction(schedule) {
  return {
    type: SCHEDULE_ACTION,
    schedule: schedule
  };
};
export function getMissingRequirements(client, schedule) {
  var venueRequirements, profileData, missingRequirements;
  return regeneratorRuntime.wrap(function getMissingRequirements$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          venueRequirements = Object.entries(deepExtract('venue.requirements.user', schedule, {})).filter(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                required = _ref2[1];

            return required;
          }).map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 1),
                requirement = _ref4[0];

            return requirement // Convert identifiers from snake_case to mixedCase
            .replace(/_(\w{1})/g, function (_
            /* ignored */
            , character) {
              return character.toUpperCase();
            });
          });
          _context.next = 3;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 3:
          profileData = _context.sent;
          missingRequirements = {
            address: !(deepExtract('contact_info.address.address1', profileData) && deepExtract('contact_info.address.city', profileData)),
            dateOfBirth: !profileData.date_of_birth,
            phone: !deepExtract('contact_info.phone', profileData),
            emergencyContact: isEmpty(profileData.emergency_contact)
          };
          return _context.abrupt("return", venueRequirements.filter(function (requirement) {
            return missingRequirements[requirement];
          }));

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function showCancelReservationModal(client, _ref5) {
  var schedule;
  return regeneratorRuntime.wrap(function showCancelReservationModal$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          schedule = _ref5.schedule;
          _context2.next = 3;
          return put(showModal('CancelReservationModal', {
            cancellationPolicy: schedule.cancellation_policy,
            credits: deepExtract('availability.credits', schedule),
            endTimestamp: shiftTimezone(schedule.endtime, schedule.venue.tz),
            image: schedule.venue.images.default,
            late: schedule.venue.late_cancellation === CANCELLATION_LATE,
            name: schedule.class.name,
            scheduleId: schedule.id,
            source: schedule.source,
            startTimestamp: shiftTimezone(schedule.starttime, schedule.venue.tz),
            studio: schedule.venue.subtitle ? "".concat(schedule.venue.name, " - ").concat(schedule.venue.subtitle) : schedule.venue.name
          }));

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function doHandleScheduleAction(client, _ref6) {
  var schedule, isUserLoggedIn, missingRequirements, isTopUp;
  return regeneratorRuntime.wrap(function doHandleScheduleAction$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          schedule = _ref6.schedule;
          _context3.next = 3;
          return select(isLoggedIn);

        case 3:
          isUserLoggedIn = _context3.sent;

          if (isUserLoggedIn) {
            _context3.next = 6;
            break;
          }

          return _context3.abrupt("return");

        case 6:
          if (!SchedulesDeriver.isReserved(schedule)) {
            _context3.next = 10;
            break;
          }

          _context3.next = 9;
          return call(showCancelReservationModal, client, {
            schedule: schedule
          });

        case 9:
          return _context3.abrupt("return");

        case 10:
          _context3.next = 12;
          return call(getMissingRequirements, client, schedule);

        case 12:
          missingRequirements = _context3.sent;

          if (isEmpty(missingRequirements)) {
            _context3.next = 17;
            break;
          }

          _context3.next = 16;
          return put(showModal('UpdateProfileModal', {
            missingRequirements: missingRequirements
          }));

        case 16:
          return _context3.abrupt("return");

        case 17:
          isTopUp = SchedulesDeriver.isTopUp(schedule);

          if (!isTopUp) {
            _context3.next = 22;
            break;
          }

          _context3.next = 21;
          return put(showModal('ReservationModal', {
            isTopUp: isTopUp,
            schedule: schedule
          }));

        case 21:
          return _context3.abrupt("return");

        case 22:
          _context3.next = 24;
          return put(showModal('ReservationModal', {
            isTopUp: isTopUp,
            schedule: schedule
          }));

        case 24:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function watchScheduleCtaSagas(client) {
  return regeneratorRuntime.wrap(function watchScheduleCtaSagas$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return fork(takeEvery, handleScheduleAction().type, doHandleScheduleAction, client);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}